const UPDATE_CART = "UPDATE_CART";

const GET_PRODUCT_LIST = "GET_PRODUCT_LIST";
const ADD_PRODUCT = "ADD_PRODUCT";
const UPDATE_PRODUCT = "UPDATE_PRODUCT";
const DELETE_PRODUCT = "DELETE_PRODUCT";
const DELETE_PRODUCTS = "DELETE_PRODUCTS"
const CLEAR_ALL_PRODUCT = "CLEAR_ALL_PRODUCT";
const SETTLE = "SETTLE";

export {
    UPDATE_CART,
    GET_PRODUCT_LIST,
    ADD_PRODUCT,
    UPDATE_PRODUCT,
    DELETE_PRODUCT,
    DELETE_PRODUCTS,
    CLEAR_ALL_PRODUCT,
    SETTLE
};



// WEBPACK FOOTER //
// ./src/store/cart/mutation-type.js